import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const doctoralCommitteeProofApi = generateProofApi('/proof-file/doctoral-committee');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('doctoral-committee', doctoralCommitteeProofApi);

export function getDoctoralCommitteeProofsByOwnerOptions(
  doctoralCommitteeId: Id,
  userId: Id,
): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(doctoralCommitteeId, userId);
}

export function getDoctoralCommitteeProofsOptions(doctoralCommitteeId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(doctoralCommitteeId);
}

export function useUploadOrUpdateDoctoralCommitteeProof(doctoralCommitteeId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(doctoralCommitteeId, queryClient));
}

export function useDeleteDoctoralCommitteeProof(doctoralCommitteeId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(doctoralCommitteeId, queryClient));
}
